<div class="drawer-container">
  <div class="button-container">
    <button
      mat-icon-button
      color="accent"
      [attr.aria-label]="sysText.close_ariaLabel"
      [disableRipple]="true"
      (click)="onCloseCaseCom()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="top-section">
    <div class="header-container">
      <h2 class="overline grey1 semibold section-title">{{sysText.caseCommunicationDrawer_title | uppercase}}</h2>
      <mat-divider class="section-header-underline"></mat-divider>
    </div>
    <!-- keeps focus while its dialog loads: showProgress lays the spinner over its content, disabledInteractive keeps it
    focusable, and the guard blocks clicks -->
    @let isLoadingSendEmailDialog = isLoadingSendEmailDialog$ | async;
    <button
      mat-stroked-button
      class="button button-height"
      color="accent"
      [disabled]="isLoadingSendEmailDialog"
      disabledInteractive
      [showProgress]="isLoadingSendEmailDialog"
      [attr.aria-label]="isLoadingSendEmailDialog ? sysText.loading_ariaLabel : null"
      (click)="!isLoadingSendEmailDialog && onSendEmail()">
      <mat-icon>email</mat-icon>
      <span>{{ sysText.caseCommunicationDrawer_sendNewEmail }}</span>
      <mat-spinner progressIndicator diameter="18" color="accent"></mat-spinner>
    </button>
  </div>
  @if ((caseComData.caseEmailSummaries?.length > 0)) {
    <!-- while an email's dialog loads its subject stays focusable (aria-disabled, the guard blocks clicks) so focus can return
    to it; the spinner takes the sender's place -->
    @let loadingEmailId = showCaseEmailIdLoading$ | async;
    @for (email of caseComData.caseEmailSummaries; track email.caseEmailId) {
      <div>
        <div class="email-container">
          <div class="text-section">
            <p class="body2 grey1 ellipsis">
              @for (rec of email.recipients; track rec; let i = $index) {
                <span
                  [matTooltip]="rec.name ? rec.email : null"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  class="contact-chip"
                  >
                  {{rec.name ?? rec.email}}
                </span>
              }
            </p>
            <p class="body2 grey6 semibold ellipsis emailTextPadding">
              <button
                type="button"
                class="button-reset openEmail"
                [attr.aria-disabled]="loadingEmailId != null || null"
                (click)="loadingEmailId == null && onEmailClick(email.caseEmailId)">
                {{email.subject}}
              </button>
            </p>
            <p class="body2 grey3 ellipsis emailTextPadding">{{email.bodyText}}</p>
          </div>
          <div class="sender-section">
            @if (loadingEmailId === email.caseEmailId) {
              <mat-spinner [diameter]="25" color="accent"></mat-spinner>
            } @else if (email.sender) {
              <app-avatar
                [name]="email.sender.description"
                [image]="email.sender.image"
                [label]="sysText.caseCommunication_sentBy + ' ' + email.sender.description">
              </app-avatar>
            }
            <p class="body2">{{email.sendDateTime | date: 'MMM d, y h:mm a'}}</p>
          </div>
        </div>
        <mat-divider class="section-underline"></mat-divider>
      </div>
    }
  } @else {
    <p class=" body2 grey1 no-history">{{sysText.caseCommunication_noHistory | capitalizefirst}}</p>
  }
</div>
